const AuthEnum = {
  WITHOUT: 'without',
  FIREBASE: 'firebase',
  TENANT: 'tenant',
  USER: 'user',
};

export default AuthEnum;
